import { apiRequest } from './api';

/**
 * NPC authoring API.
 *
 * Thin wrappers over `apiRequest` so components never assemble URLs or auth
 * headers themselves — the same shape as `services/sprites.js`.
 *
 * EVERY ROUTE HERE IS ADMIN-ONLY, and that is enforced by `adminAuth` on the
 * server. Hiding the recorder from non-admins is a rendering decision, not a
 * security one: the server re-validates every waypoint on save regardless of
 * what the client believes it is allowed to do.
 */

export const listNpcs = (token) => apiRequest('/api/npcs', { token });

/**
 * Map geometry for the route preview — tiles, not world units.
 *
 * Maps otherwise travel only over the socket in WELCOME, and the admin page has
 * no socket. This is that gap, not a general map API.
 */
export const getMapGeometry = (token, mapName) => apiRequest(`/api/npcs/maps/${mapName}`, { token });

export const createNpc = (token, npc) => apiRequest('/api/npcs', {
  method: 'POST', token, body: npc,
});

export const updateNpc = (token, id, changes) => apiRequest(`/api/npcs/${id}`, {
  method: 'PUT', token, body: changes,
});

export const deleteNpc = (token, id) => apiRequest(`/api/npcs/${id}`, {
  method: 'DELETE', token,
});

/**
 * Publishing is its own call, not a field on `updateNpc`.
 *
 * The server refuses `status` on PUT for the same reason: introducing a
 * character to everyone is a deliberate act, and a form save should never be
 * able to do it as a side effect.
 */
export const publishNpc = (token, id) => apiRequest(`/api/npcs/${id}/publish`, {
  method: 'POST', token,
});

export const unpublishNpc = (token, id) => apiRequest(`/api/npcs/${id}/unpublish`, {
  method: 'POST', token,
});
